import { useState } from "react";
import { Navigate } from "react-router-dom";
import { Landmark, Loader2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";

export default function Login() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/panel" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try { await login(email, password); } catch (err) { setError(apiError(err).message); } finally { setLoading(false); }
  };

  return (
    <div className="admin-shell grid min-h-screen lg:grid-cols-2">
      <div className="relative hidden overflow-hidden bg-[#0D1117] lg:block">
        <img src="/hotels/hard-rock.jpg" alt="" className="absolute inset-0 h-full w-full object-cover opacity-40" />
        <div className="relative flex h-full flex-col justify-end p-14 text-white">
          <p className="font-heading text-5xl font-semibold leading-tight">Panel de cobros</p>
          <p className="mt-4 max-w-md text-slate-300">Seis plantillas, una sola consola. Enlaces seguros y seguimiento de cada pago.</p>
        </div>
      </div>
      <div className="flex items-center justify-center bg-[#F5F6F8] px-6 py-12">
        <form onSubmit={submit} className="w-full max-w-sm space-y-6" data-testid="login-form">
          <div className="grid h-12 w-12 place-items-center rounded-xl bg-[#2F5BFF] text-white"><Landmark size={22} /></div>
          <div>
            <h1 className="font-heading text-3xl font-semibold text-slate-900">Iniciar sesión</h1>
            <p className="mt-1 text-sm text-slate-500">Acceso exclusivo para personal autorizado.</p>
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="email">Correo electrónico</Label>
            <Input id="email" type="email" required autoComplete="email" data-testid="login-email-input" value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="password">Contraseña</Label>
            <Input id="password" type="password" required autoComplete="current-password" data-testid="login-password-input" value={password} onChange={(e) => setPassword(e.target.value)} />
          </div>
          {error && <p className="rounded-lg bg-rose-50 px-3 py-2 text-sm text-rose-700" data-testid="login-error">{error}</p>}
          <button type="submit" disabled={loading} data-testid="login-submit-button"
            className="flex w-full items-center justify-center gap-2 rounded-full bg-[#2F5BFF] px-6 py-3 font-semibold text-white transition-[background-color,transform] duration-200 hover:bg-[#1F45E0] active:scale-[0.98] disabled:opacity-60">
            {loading && <Loader2 size={16} className="animate-spin" />} Entrar
          </button>
        </form>
      </div>
    </div>
  );
}
